export default __webpack_public_path__ + "f4c7ac8e9ec54bbfdffa0c46eb161f8a.png";